export default __webpack_public_path__ + "static/media/prisma.1a423947.svg";